<!--begin header -->
<header class="header">
    <app-header></app-header>
</header>
<!--end header -->
<!DOCTYPE html>
<!--
Emerio by @arun kumar g
-->
<html>
<head>
    <link rel="shortcut icon" type="image/x-icon" href="favicon.ico">
    <meta charset="UTF-8">
    <meta http-equiv="Content-Language" content="en-SG"> 
    <meta name="language" content="English"> 
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="generator" content="Mobirise v2.11.1, mobirise.com">
    <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1.0"/>
    
    <title>AUTHORISATION - SingX</title>
    <meta name="description" content="">
    <meta name="keywords" content="indian bank money transfer, bank wire transfer fees, how to transfer money to overseas bank account, compare money transfer to india, best rate to send money to india, money to india rates, cheapest way to transfer money overseas, money transfer rate to india, india money transfer rate, best international money transfer, best transfer rate to india, cheapest way to send money to india, cheapest way to transfer money to india, best way to transfer money to india"> 


  
    <!-- popup window starts -->
    <style>
         

        body {
            justify-content: center; 
            align-items: center;

        }

        .container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding: 0 20px; }

        .black_overlay {
            display: none;
            position: fixed;
            top: 0%;
            left: 0%;
            width: 100%;
            height: 100%;
            background-color: black;
            z-index: 1001;
            opacity: 0.8;
        }
        .white_content {
            display: none;
            position: fixed;
            top: 2%;
            left: 2%;
            width: 97%;
            height: 97%;
            padding: 1px;
            border: 6px solid #2c82c9;
            background-color: white;
            z-index: 1002;
            overflow: auto;
        }
        strong {
              color: #FF6600;
          }

          .request-access {
            margin-bottom: 50px; 
          }
    
    </style>
    <!-- popup window ends -->  
    
    <script>
        (function(i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r; 
            i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date(); 
            a = s.createElement(o), m = s.getElementsByTagName(o)[0]; 
            a.async = 1; 
            a.src = g; 
            m.parentNode.insertBefore(a, m)
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
        
        ga('create', 'UA-79844014-1', 'auto');
        ga('send', 'pageview');
    </script> 
</head>
<body>
    <nav id="myNavbar" class="navbar navbar-default navbar-inverse navbar-fixed-top circle" role="navigation" style="background-color: white; min-height: 68px;">
    </nav>
         
    <div class="container body_background ng-scope" style="padding-top: 94px;">
        <div align="center" class="azh-topheader-30 azh-padding-bottom-0 regular_20 color_orange body_background">
            <h1 class="mbr-header__text" style="color: #ff6600; font-size: 42px;">Authorisation</h1>
        </div>
        <br>
        <div class="col-sm-8 col-sm-offset-2" style="justify-content: center; align-items: center; 
            margin: 0;">
            <p class="regular_14 color_lightgrey">
                I warrant that the declared information is true and correct and by submitting this form, I request that an Account be set up for me. I understand that failure to provide information may prevent processing of this application and result in a cancellation of my application. I confirm that I have read the Terms and Conditions and agree to be bound by the same. <br><br>
                I authorise you and your affiliates to use information about me, including information regarding my transaction history for administrative purposes and to share such information with each other as detailed further below.<br><br>
                I understand that SingX Pte Ltd may decline this application at its sole discretion without giving any reason and without entering into any correspondence. 
            </p>

            <p class="regular_bold_14 color_orange">
                Data Protection and Use of Personal Data <br><br>
            </p>
            <p class="regular_14 color_lightgrey">
                <strong> (1) Disclosure of Personal Information </strong><br><br>
                I agree that any information provided by me in the application form, at your request, or otherwise collected during the operation of my Account (“Personal Information”) may be disclosed to:
            </p>
            <ol type="1" class="regular_14 color_lightgrey">
                <li>Companies within the worldwide SingX Group of companies (“SingX Group companies”);</li>
                <li>Licensed Remittance Operators who have signed confidentiality undertakings with SingX Pte Ltd and who require such information to comply with regulatory requirements in their market and to process the transaction which is to be undertaken with SingX;</li>
                <li>Processors and suppliers SingX may engage;</li>
                <li>The providers of services and benefits associated with my Account;</li>
                <li>Anyone to whom we may transfer contractual rights; and</li>
                <li>Any other party approved by me or to whom SingX considers it in its interests to make such disclosure.</li>
            </ol>

            <p class="regular_14 color_lightgrey">
                <strong> (2) Use of Information </strong> <br><br>
                SingX may use my Personal Information, including aggregated or combined with other information for the purposes as set out in the Privacy Policy which includes any of the following purposes:  
                </p><ol type="1" class="regular_14 color_lightgrey">
                <li>    Delivering SingX products and services to me, including the management and operation of my account;</li>

                <li>   Improving SingX products and services and to conduct research and analysis which may be shared in aggregated form with the manufacturers and distributors of products under services which I have taken or which in SingX’s opinion may be of use ;</li>
        
                </ol>
                
                <p> My data may also be used for other purposes for which I have given specific permission, or when required by law, or where permitted under the terms of applicable privacy laws.</p>
                
                
            <p class="regular_14 color_lightgrey">
                <strong> (3) International Transfer of Data </strong>  <br>
                </p>
                
                <p> Personal Information may be processed, accessed or disclosed in countries outside Singapore for the purpose of administering my Account. In such cases, SingX will take appropriate steps to ensure the same level of protection for the information in other countries outside Singapore.</p>
                
            <p class="regular_14 color_lightgrey">
                <strong> (4) Retention of Information </strong>   <br>
                </p>
                
                <p> SingX keeps Personal Information for the purposes described in this statement for as long as is appropriate to fulfill its legal obligations in accordance with applicable law.</p>
                
            <p class="regular_14 color_lightgrey">
                <strong> (5) Access and Correction </strong>  <br>
                </p>
                
                <p class="request-access">
                    I am entitled at any time to request access to information held by SingX about me or my Account and to update and correct such information. I agree that SingX may impose a modest charge to cover the costs of complying with such requests. Please make such requests in writing to the Data Privacy Officer, SingX Pte Ltd at <a href="mailto:help@singx.co">help&#64;singx.co</a>
                </p>
        </div>
    </div>
    <app-footer></app-footer>
</body>
</html>